import { useDispatch, useSelector } from 'react-redux';
import { taskBoardActions } from '../../../../store/slices/taskBoardSlice/taskBoardSlice';
import { useCallback } from 'react';

export const useModalTasksMonth = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { modalMode } = useSelector((store) => store.taskBoardReducer);

    const onHideModal = useCallback(() => {
        dispatch(taskBoardActions.onModalMode(null));
    }, []);
    return { modalMode, onHideModal };
};
